import React from 'react';
import { createStyles, makeStyles, useTheme } from '@material-ui/core';
import { Subtitle } from '../text';
import SimpleList from './SimpleList';
import clsx from 'clsx';

const useStyles = makeStyles((theme) =>
  createStyles({
    wrapper: {
      color: theme.palette.text.primary,
    },
    active: {
      '& nav': {
        paddingBottom: 0,
      },
    },
    deactive: {
      textDecoration: 'line-through',
      color: '#ccc',
      '& span': {
        color: '#ccc',
      },
    },
  }),
);

interface Props {
  active: boolean;
  items: Array<{ id: string; description: string }>;
  title?: string;
}

const PackageDescriptionList: React.FC<Props> = (props: Props) => {
  const { items, active, title } = props;
  const classes = useStyles();
  const theme = useTheme();
  return (
    <div className={clsx(active ? classes.active : classes.deactive, classes.wrapper)}>
      {title && <Subtitle style={{ marginBottom: '10px', fontWeight: 'bold' }}>{title}</Subtitle>}
      <SimpleList
        items={items.map((attr: { id: string; description: string }) => ({ id: attr.id, title: attr.description }))}
        checked
        checkedWidth={15}
        checkedHeight={15}
        color={active ? theme.palette.secondary.main : '#ccc'}
        withoutListDecorator={!active}
      />
    </div>
  );
};

export default PackageDescriptionList;
